import { render, staticRenderFns } from "./EstimateInfo.vue?vue&type=template&id=587250c4&scoped=true&"
import script from "./EstimateInfo.vue?vue&type=script&lang=js&"
export * from "./EstimateInfo.vue?vue&type=script&lang=js&"
import style0 from "./EstimateInfo.vue?vue&type=style&index=0&id=587250c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587250c4",
  null
  
)

export default component.exports